import { API_ENDPOINTS } from "../../constants/common";
import { WEBHOOK_TYPES } from "../../constants/strings";
import { api } from "../../utils/api";

export const fetchWebhookConfiguration = (accountNumber, businessUnit) =>
  api
    .get({
      path: `${API_ENDPOINTS.WEBHOOKS}/config`,
      query: {
        accountNumber,
        ...(businessUnit && { businessUnit }),
      },
    })
    .then(({ data }) => data);

export const generateWebhookSecret = (accountNumber, type, businessUnit) =>
  api
    .post({
      path: `${API_ENDPOINTS.WEBHOOKS}/generateSecret`,
      query: {
        accountNumber,
        type,
        businessUnit,
      },
    })
    .then(({ data }) => data);

export const revokeWebhookSecret = (
  accountNumber,
  secretId,
  type,
  businessUnit
) =>
  api
    .put({
      path: `${API_ENDPOINTS.WEBHOOKS}/secret/revoke`,
      query: {
        accountNumber,
        type,
        businessUnit,
      },
      body: {
        secretId,
      },
    })
    .then(({ data }) => data);

export const updateWebhookConfiguration = (
  accountNumber,
  type,
  businessUnit,
  url,
  enabledTypes,
  webhookIsEnabled,
  secretStatus
) => {
  let enabledTypeToggles;
  switch (type) {
    case WEBHOOK_TYPES.EVENT:
      enabledTypeToggles = { enabledEventTypes: enabledTypes };
      break;
    default:
      enabledTypeToggles = { enabledNotificationTypes: enabledTypes };
  }

  return api
    .put({
      path: `${API_ENDPOINTS.WEBHOOKS}/save`,
      query: {
        accountNumber,
        type,
        businessUnit,
      },
      body: {
        url,
        ...enabledTypeToggles,
        webhookIsEnabled,
        secretStatus,
      },
    })
    .then(({ data }) => data);
};

export const fetchSuspendedSecrets = (accountNumber, businessUnit) =>
  api
    .get({
      path: `${API_ENDPOINTS.WEBHOOKS}/secret/suspended`,
      query: {
        accountNumber,
        businessUnit,
      },
    })
    .then(({ data }) => data);

export const reactivateWebhookSecret = (
  accountNumber,
  secretId,
  type,
  businessUnit
) =>
  api
    .put({
      path: `${API_ENDPOINTS.WEBHOOKS}/secret/reactivate`,
      query: {
        accountNumber,
        businessUnit,
        type,
      },
      body: {
        secretId,
      },
    })
    .then(({ data }) => data);

export const testWebhook = (accountNumber, type, businessUnit, formData) =>
  api
    .post({
      path: `${API_ENDPOINTS.WEBHOOKS}/test`,
      query: {
        accountNumber,
        type,
        businessUnit,
      },
      body: formData,
    })
    .then(({ data }) => data);
